module.exports = __webpack_public_path__ + "img/davivienda.31400be1.png";